export function isPipAvailable(data) {
  let result = false;
  const { player, videoElement } = data;

  if (
    isBrowserOk(player) &&
    (document.pictureInPictureEnabled ||
      typeof videoElement.webkitSupportsPresentationMode === 'function')
  ) {
    result = true;
  }

  return result;
}

function isBrowserOk(player) {
  let result = true;
  const browser = player.config.device?.browser;

  if (
    browser &&
    browser.name.toLowerCase() === 'safari' &&
    parseInt(browser.major) >= 26
  ) {
    result = false;
  }

  return result;
}
